// extracted by mini-css-extract-plugin
module.exports = {"title":"acceptDialog_title__XZnRX"};
    if(module.hot) {
      // 1783592041266
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  